// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".destination-control-item {\n    display: flex;\n    align-items: center;\n}\n\n.control-label {\n    margin: 0;\n}\n\n.qr-text {\n    display: inline-block;\n    padding-right: 25px;\n    font-weight: bold;\n}\n\n.link {\n    margin-bottom: 8px;\n}\n\n", ""]);
// Exports
module.exports = exports;
